import { inject } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { LanguageService } from 'src/app/services/language.service';

export class BaseServiceComponent {
    protected _languageService = inject(LanguageService);
    protected _apiService = inject(ApiService);
}
